/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../apimodel.d.ts" />
/// <reference path="errordetail.ts" />

module App.Common {

	export class ErrorDetails {

		public title = 'Sorry, an unexpected error has occured';

		public userMessage: string;

		public showTechnicalDetails = false;

		public errorDetails: ErrorDetail[] = [];

		public add(detail: ErrorDetail) {
			this.errorDetails.push(detail);
		}

	}

}